import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-page-internal-server-error',
    templateUrl: './page-internal-server-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageInternalServerErrorComponent {

}
